<template>
    <modal id="support-email-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('email')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/settings/support-email`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-12">
                    <app-form-group
                        type="email"
                        v-model="formData.email"
                        :label="$t('email')"
                        :placeholder="$placeholder('email', '')"
                        :error-message="$errorMessage(errors, 'email')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        list-value-field="name"
                        type="multi-select"
                        :label="$t('category')"
                        v-model="formData.categories"
                        :chooseLabel="$t('category')"
                        :error-message="$errorMessage(errors, 'categories')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/ticket/category`"
                    />
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('remark') }}</label>
                        <app-input
                            row="3"
                            type="text-editor"
                            id="text-editor-for-template"
                            v-model="formData.remark"
                            :placeholder="$textAreaPlaceHolder('remark')"
                            :error-message="$errorMessage(errors, 'remark')"
                        />
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "SupportEmailCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            formData: {},
        }
    },
    methods: {
        submitData() {
            this.loading = true

            let url      = this.$refs.form.dataset['url'];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.formData.categories) {
                formData.set('categories', JSON.stringify(this.formData.categories))
            }

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#support-email-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'support-email-table');
            this.$hub.$emit('reload-data-support-email', data.support_email);
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
        },
    },
}
</script>

